<slotcom-navigation-button
  type="close"
  (click)="closeModal()">
</slotcom-navigation-button>

<div class="c-promoCodeExpiredModal">
  <div class="c-promoCodeRedeemedModal__image">
    <div class="c-promoCodeExpiredModal__title">
      <span>{{ 'home.lobby.modals.promo-code-expired.title' | translate }}</span>
    </div>

    <div class="c-promoCodeExpiredModal__subtitle">
      <span>{{ 'home.lobby.modals.promo-code-expired.subtitle' | translate }}</span>
    </div>

    <slotcom-button
      class="c-button--pink"
      (safeClick)="goToShop()"
      audioType="functionality">
      {{ 'home.buttons.go-to-store' | translate | uppercase }}
    </slotcom-button>
  </div>
</div>
